var mentions_default = {
  "mentionPalette": "n4aHP",
  "mention": "DUq3h",
  "mentionViewer": "ZD-BU",
  "mentionSuggestionsEntry": "CiwKJ",
  "mentionSuggestionsEntryFocused": "rtCyg",
  "mentionSuggestionsEntryText": "VDq2s",
  "mentionSuggestionsEntryAvatar": "_6QzSW",
  "mentionSuggestions": "v2Aoi",
  "cursorDefault": "uTr9r",
  "cursorPointer": "BlJD1"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
